import { reactive } from 'vue'
import { Bl } from '@/models/Bl'

export interface BescProgression {
  step1Completed: boolean
  step2Completed: boolean
  step3Completed: boolean
  step4Completed: boolean 
  recap_completed: boolean 
  step1_completed_at?: string | null
  step2_completed_at?: string | null
  step3_completed_at?: string | null
  step4_completed_at?: string | null
  final_submitted_at?: string | null
  currentStep?: number
  lastStepCompletedAt?: string | null
  isFinalized?: boolean
}

export const bescWizard = reactive({
  bescId: null as string | null,
  
  progression: {
    step1Completed: false,
    step2Completed: false,
    step3Completed: false,
    step4Completed: false,
    recap_completed: false,
    step1_completed_at: null,
    step2_completed_at: null,
    step3_completed_at: null,
    step4_completed_at: null,
    final_submitted_at: null,
    currentStep: 1,
    lastStepCompletedAt: null,
    isFinalized: false
  } as BescProgression,

  step1: {
    importateur: '',
    partieANotifier: '',
    transitaire: '',
    expediteur: '',
    transporteur: '',
    numeroConnaissement: '',
    incoterm: null as number | null,
    paysOrigine: null as number | null,
    typeFret: null as number | null,
    destinationFinale: null as number | null,
    vessel: null as number | null,
    portChargement: null as number | null,
    portDechargement: null as number | null,
    transbordement: 'non',
    navireApresTransbordement: null as number | null,
    transporteurApresTransbordement: '',
    etd: '',
    eta: ''
  },

  step2: {
    listeBLs: [] as Bl[]
  },
  step3: {
    pieces: [
      { type_id: null, fichier: null, filename: '' }
    ] as any[]
  }
})

export function resetBescWizard() {
  bescWizard.bescId = null

  bescWizard.progression = {
    step1Completed: false,
    step2Completed: false,
    step3Completed: false,
    step4Completed: false,
    recap_completed: false,
    step1_completed_at: null,
    step2_completed_at: null,
    step3_completed_at: null,
    step4_completed_at: null,
    final_submitted_at: null,
    currentStep: 1,
    lastStepCompletedAt: null,
    isFinalized: false
  }

  Object.assign(bescWizard.step1, {
    importateur: '',
    partieANotifier: '',
    transitaire: '',
    expediteur: '',
    transporteur: '',
    numeroConnaissement: '',
    incoterm: null,
    paysOrigine: null,
    typeFret: null,
    destinationFinale: null,
    vessel: null,
    portChargement: null,
    portDechargement: null,
    transbordement: 'non',
    navireApresTransbordement: null,
    transporteurApresTransbordement: '',
    etd: '',
    eta: ''
  })

  bescWizard.step2.listeBLs.splice(0)

  bescWizard.step3.pieces.splice(
    0,
    bescWizard.step3.pieces.length,
    { type_id: null, fichier: null, filename: '' }
  )
}

export function loadBescProgression(progression: BescProgression) {
  bescWizard.progression = { ...progression }
}

export async function saveBescProgressionToAPI(bescId: string, step: number) {
  try {
    console.log('Enregistrement de la progression du BESC pour l’ID:', bescId, 'Step:', step)
    
    const { default: ApiService } = await import('@/services/ApiService')
    
    await ApiService.patch(`/besc/${bescId}/progression`, {
      step: step,
      completed: true
    })
    
    console.log('Progression enregistrée avec succès')
    
  } catch (error) {
    console.error('Erreur lors de l’enregistrement de la progression du BESC:', error)
  }
}

export async function loadBescProgressionFromAPI(bescId: string) {
  try {
    console.log('Chargement de la progression du BESC pour l’ID:', bescId)
    
    const { default: ApiService } = await import('@/services/ApiService')
    
    const response = await ApiService.get(`/besc/${bescId}/progression`)
    const progressionData = response.data.data
    
    console.log('Données de progression chargées:', progressionData)
    
    if (progressionData) {
      const progression: BescProgression = {
        step1Completed: progressionData.step1Completed || false,
        step2Completed: progressionData.step2Completed || false,
        step3Completed: progressionData.step3Completed || false,
        step4Completed: progressionData.recap_completed || false, 
        recap_completed: progressionData.recap_completed || false,
        step1_completed_at: null,
        step2_completed_at: null,
        step3_completed_at: null,
        step4_completed_at: progressionData.lastStepCompletedAt || null,
        final_submitted_at: progressionData.lastStepCompletedAt || null,
        currentStep: progressionData.currentStep || 1,
        lastStepCompletedAt: progressionData.lastStepCompletedAt || null,
        isFinalized: progressionData.isFinalized || false
      }
      
      console.log('Progression mappée', progression)
      loadBescProgression(progression)
    }
    
  } catch (error) {
    console.error('Erreur lors du chargement de la progression du BESC:', error)
    const defaultProgression: BescProgression = {
      step1Completed: false,
      step2Completed: false,
      step3Completed: false,
      step4Completed: false,
      recap_completed: false,
      step1_completed_at: null,
      step2_completed_at: null,
      step3_completed_at: null,
      step4_completed_at: null,
      final_submitted_at: null,
      currentStep: 1,
      lastStepCompletedAt: null,
      isFinalized: false
    }
    loadBescProgression(defaultProgression)
  }
}

export function updateStepProgression(step: 'step1' | 'step2' | 'step3' | 'final', completed = true) {
  const now = completed ? new Date().toISOString() : null
  
  let stepNumber: number
  
  switch (step) {
    case 'step1':
      bescWizard.progression.step1Completed = completed
      bescWizard.progression.step1_completed_at = now
      bescWizard.progression.currentStep = completed ? 2 : 1
      stepNumber = 1
      break
    case 'step2':
      bescWizard.progression.step2Completed = completed
      bescWizard.progression.step2_completed_at = now
      bescWizard.progression.currentStep = completed ? 3 : 2
      stepNumber = 2
      break
    case 'step3':
      bescWizard.progression.step3Completed = completed
      bescWizard.progression.step3_completed_at = now
      bescWizard.progression.currentStep = completed ? 4 : 3
      stepNumber = 3
      break
    case 'final':
      bescWizard.progression.step4Completed = completed
      bescWizard.progression.recap_completed = completed
      bescWizard.progression.step4_completed_at = now
      bescWizard.progression.final_submitted_at = now
      bescWizard.progression.isFinalized = completed
      stepNumber = 4
      break
    default:
      return
  }
  
  if (completed) {
    bescWizard.progression.lastStepCompletedAt = now
  }
  
  if (bescWizard.bescId) {
    saveBescProgressionToAPI(bescWizard.bescId, stepNumber).catch(console.error)
  }
}

export function calculateProgressionPercentage(): number {
  const { step1Completed, step2Completed, step3Completed, recap_completed } = bescWizard.progression
  
  let completed = 0
  if (step1Completed) completed += 25
  if (step2Completed) completed += 25
  if (step3Completed) completed += 25
  if (recap_completed) completed += 25
  
  return completed
}

export function getNextStep(): string | null {
  const { step1Completed, step2Completed, step3Completed, step4Completed } = bescWizard.progression
  
  if (!step1Completed) return 'AddBescStep1'
  if (!step2Completed) return 'AddBlStep2'
  if (!step3Completed) return 'AddBescStep3'
  if (!step4Completed) return 'Recapitulatif'
  
  return null 
}

export function canAccessStep(step: 'step1' | 'step2' | 'step3' | 'final'): boolean {
  const { step1Completed, step2Completed, step3Completed } = bescWizard.progression
  
  switch (step) {
    case 'step1':
      return true 
    case 'step2':
      return step1Completed
    case 'step3':
      return step1Completed && step2Completed
    case 'final':
      return step1Completed && step2Completed && step3Completed
    default:
      return false
  }
}

export async function resetBescProgressionAPI(bescId: string) {
  try {
    console.log('Resetting BESC progression for ID:', bescId)
    
    const { default: ApiService } = await import('@/services/ApiService')
    
    await ApiService.delete(`/besc/${bescId}/progression`)
    
    resetBescWizard()
    
    console.log('Progression reset successfully')
    
  } catch (error) {
    console.error('Error resetting BESC progression:', error)
  }
}
